import { QueryKey, useQuery } from "react-query";
import { getPermitAttachments } from "../../../queries/permits";
import useNetworkHeaders from "../../../hooks/useNetworkHeaders";

export const usePermitAttachments = ({ permitId }: { permitId: string | number }) => {
  const networkHeaders = useNetworkHeaders();
  const key = getPermitAttachmentsQueryKey(permitId);
  const attachmentsQuery = useQuery(key, getPermitAttachments(networkHeaders));
  return {
    data: attachmentsQuery.data,
    isLoading: attachmentsQuery.isLoading,
  };
};

export const getPermitAttachmentsQueryKey = (permitId: string | number): QueryKey => {
  return ["attachments", permitId.toString()];
};
